import { useCallback } from "react";
import type { FieldConfiguration } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { MeasureField } from "../../../../../../../../api/types/svTypes.ts";
import { useBiCommonDataContext } from "../../../../contexts/BiCommonDataContext.ts";
import { useAppDispatch } from "../../../../store/hooks/useAppDispatch.ts";
import { createFinancialStatementAction } from "../../../../store/utils/storeUtils.ts";
import FieldConditionsPanel from "../common/FieldConditionsPanel.tsx";
import { getLinkableLineConditions } from "../utils/statementLineOptions.ts";

interface Props {
  lineGuid: string;
  field: MeasureField;
  readonly: boolean;
  popupAnchorEl: HTMLElement | undefined;
  onClosePopup: () => void;
}

const LineConditionsPanel = ({ lineGuid, field, readonly, popupAnchorEl, onClosePopup }: Props) => {
  const dispatch = useAppDispatch();
  const { dimensions, conditions } = useBiCommonDataContext();

  const handleUpdateField = useCallback(
    (changes: Partial<FieldConfiguration>) =>
      dispatch(createFinancialStatementAction("updateLineField", { guid: lineGuid, changes })),
    [dispatch, lineGuid]
  );

  return (
    <FieldConditionsPanel
      field={field}
      dimensions={dimensions}
      globalConditions={getLinkableLineConditions(conditions)}
      canToggleParameter
      readonly={readonly}
      popupAnchorEl={popupAnchorEl}
      onClosePopup={onClosePopup}
      onUpdateField={handleUpdateField}
    />
  );
};

export default LineConditionsPanel;
